import React from "react";

export default function Facebook(props) {
  return (
    <svg
      id="facebook_logo"
      data-name="facebook logo"
      xmlns="http://www.w3.org/2000/svg"
      width="34.483"
      height="34.483"
      viewBox="0 0 34.483 34.483"
    >
      <circle
        id="Ellipse_20"
        data-name="Ellipse 20"
        cx="17.241"
        cy="17.241"
        r="17.241"
        transform="translate(0 0)"
        fill="#fff"
      />
      <path
        id="Path_69"
        data-name="Path 69"
        d="M47.767,32.991H44.69V44.261H40.029V32.991H37.812V29.029h2.217V26.466c0-1.833.871-4.7,4.7-4.7l3.453.014v3.845H45.679a.949.949,0,0,0-.989,1.08v2.331h3.483Z"
        transform="translate(-26.191 -15.074)"
        fill="#3b5999"
      />
    </svg>
  );
}
